import { Container, Heading, Button, Box, Text, Image, useMediaQuery } from '@chakra-ui/react';

interface IHeroProps {
  buttonText?: string;
  href?: string;
  subtitle?: string;
  title: string;
}

export const Hero: React.FC<IHeroProps> = (props): JSX.Element => {
  const { buttonText, href = '#', subtitle, title } = props;
  const [isLargerThan768] = useMediaQuery('(min-width: 48em)');
  const image = isLargerThan768 ? 'hero' : 'hero-mb';
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" w="100%">
      <Image
        h="100vh"
        objectFit="cover"
        src={`/images/${image}.webp`}
        srcSet={`/images/${image}@2x.webp 2x, /images/${image}@3x.webp 3x`}
      />
      <Container color="white" maxW="full" position="absolute" py={24} textAlign="center">
        <Heading
          as="h1"
          fontSize={{ base: 'h1.base', md: 'h1.md' }}
          pb={8}
          textTransform="uppercase"
        >
          {title}
        </Heading>
        {subtitle && (
          <Text as="h2" fontSize={{ base: 'h2.base', md: 'h2.md' }} pb={8}>
            {subtitle}
          </Text>
        )}
        {buttonText && (
          <Button as="a" href={href} variant="mbePrimary">
            {buttonText}
          </Button>
        )}
      </Container>
    </Box>
  );
};
